import { render } from "./Codesync.vue?vue&type=template&id=dd97dd7c"
import script from "./Codesync.vue?vue&type=script&lang=js"
export * from "./Codesync.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__